module.exports = __webpack_public_path__ + "img/single-neutral-actions-edit-2.8e4695fe.svg";